import React, { useCallback, useContext } from 'react'
import { PageContext } from '../../../../contexts/page-context'

import { navHelper } from '../../../../lib/services/navigation'
import { gnarSpec } from '../../../../lib/tracking/gnar'
import { trackGA4BtnClick } from '../../../../lib/tracking/google-tag-manager/events'
import { TypeComponentLink } from '../../../../lib/types'
import { waitGnar } from '../../../../lib/utils/promise'
import { ButtonCta, ButtonCtaProps } from '../../../ui-lib/button'
import { CtaTrackingProps } from '../types'

export interface LinkButtonProps extends Omit<ButtonCtaProps, 'onClick'>, CtaTrackingProps {
  targetLink: TypeComponentLink
}

export const LinkButton: React.FC<LinkButtonProps> = (props) => {
  const { targetLink, placement, placementInternalName, ...restProps } = props
  const { internalName, targetUrl, appendCurrentQueryParams } = targetLink.fields
  const { pageId, slug } = useContext(PageContext)

  const onClick = useCallback(async () => {
    trackGA4BtnClick(placement)
    // TODO: distinguish between different links
    await waitGnar(
      gnarSpec.customLinkCtaButtonClick(internalName, pageId, slug, targetUrl, placement, placementInternalName)
    )

    navHelper.navigateUrl(targetUrl, appendCurrentQueryParams ? navHelper.currentQueryParams : undefined)
  }, [internalName, pageId, slug, placement, placementInternalName, targetUrl, appendCurrentQueryParams])

  if (targetUrl.startsWith('#')) {
    return <ButtonCta {...restProps} as="a" href={targetUrl} />
  }

  return <ButtonCta {...restProps} onClick={onClick} />
}
